<!--头部-->
<template>
  <section class="app-header" :class="{isWhite}">
    <div class="header-main container-width">
      <z-logo :dark="isWhite" />
      <div class="extend">
        <z-nav :dark="isWhite" />
      </div>
    </div>
  </section>
</template>

<script>
import zNav from '../nav'
import zLogo from '@/components/h5/logo'
export default {
  name: 'AppHeader',
  components: {
    zNav,
    zLogo
  },
  props: {},
  computed: {},
  data() {
    return {
      isWhite: false
    }
  },
  mounted() {
    this.init()
    document.onscroll = this.init
  },
  methods: {
    init() {
      const sTop = document.querySelector('html').scrollTop
      if (sTop === 0) {
        this.isWhite = false
      } else {
        this.isWhite = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  padding: 2.6vw 3.7vw;
  transition: all 300ms;
  .header-main {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &.isWhite {
    background: #FFFFFF;
    box-shadow: 0px 20px 20px 0px rgba(0,0,0,0.05);
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/h5/header/index.vue